import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";

const Badge = ({ type, className, children }) => (
  <span
    className={cn(
      "inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium leading-5",
      className,
      {
        "bg-gray-100 text-gray-800": type === "",
        "bg-blue-100 text-blue-800": type === "primary",
        "bg-yellow-100 text-yellow-800": type === "warning"
      }
    )}
  >
    {children}
  </span>
);

Badge.defaultProps = {
  type: "",
  className: "",
  children: ""
};

Badge.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

export default Badge;
